import RegistrationService from 'services/registration';
import DevicesService from 'services/devices.services';
import GroupWallpaperService from 'services/grpWallpaper.services';
import NotificationService from 'services/notification.service';
import LocationService from 'services/location.service';
import PmsCustomerService from 'services/pms.customer.service';
import DeviceInfoService from 'services/deviceInfo.service';
import PatientService from 'services/patient.service';
import ThirdPartyService from 'services/thirdParty.service';
import CallThirdPartyService from 'services/callthirdParty.service';
import GetThirdParty from 'services/http/http.service';
import LatestNewsService from 'services/latestNews.service';
import WelcomeNoteService from 'services/welcomeNote.service';
import AccreditationService from 'services/accreditations.service';
import SliderTimerService from 'services/sliderTimer.service';
import ProfileCategoryService from 'services/profileCategories.service';
import ProfileService from 'services/profile.service';
import OrganizationChannelService from 'services/orgChannel.service';
import OrganizationGroupChannelService from 'services/orgGroupChannel.service';
import OrganizationTemplateService from 'services/orgTemplate.service';
import OrganizationGroupTemplateService from 'services/orgGroupTemplate.service';
import OrganizationThemeService from 'services/orgTheme.service';
import OrganizationGroupThemeService from 'services/orgGroupTheme.service';
import LanguageService from 'services/language.service';
import DeviceRoomService from 'services/devicesforRoom.service';
import liveScreenService from 'services/liveScreens.service';
import proxyServerService from 'services/proxyServer.service';
import organizationService from 'services/organization.service';
import TrackingService from 'services/tracking.service';
import OrganizationGroupService from 'services/orgGroup.service';
import AWSUrlProcessorService from 'services/awsUrlProcessor.service';

const obj = {
  RegistrationService,
  DevicesService,
  GroupWallpaperService,
  NotificationService,
  LocationService,
  ThirdPartyService,
  CallThirdPartyService,
  GetThirdParty,
  LatestNewsService,
  WelcomeNoteService,
  AccreditationService,
  SliderTimerService,
  ProfileCategoryService,
  ProfileService,
  OrganizationChannelService,
  OrganizationGroupChannelService,
  OrganizationTemplateService,
  OrganizationGroupTemplateService,
  OrganizationGroupThemeService,
  OrganizationThemeService,
  LanguageService,
  DeviceRoomService,
  PmsCustomerService,
  DeviceInfoService,
  PatientService,
  liveScreenService,
  proxyServerService,
  organizationService,
  TrackingService,
  OrganizationGroupService,
  AWSUrlProcessorService
};

export default obj;
